/*
  GD hero FX: the pixel title intro shared by every picture hero
  (GD - Service Page, GD - Case Study Page, GD - Services Index, GD - Home).

  The H1 is sampled into brand pixels at its laid-out size.
    data-hfx-hero="resolve"   pixels appear in place at once (a short stepped jitter),
                              then dissolve left to right into the real title (< 1s)
    data-hfx-hero="assemble"  pixels fly in from the edges and land as the title,
                              then dissolve into it (GD - Home, ~1.3s)
  A [data-swap] word inside the title changes through a pixel dissolve.

  Only runs while something is animating. Reduced motion: nothing runs.
  The inline guard in the hero shows the title after 2.5s whatever happens.
*/
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LIME = '#CFFF00', ELEC = '#0048FF', WHITE = '#FFFFFF', R = 0.24;

  function rr(ctx, x, y, s) {
    if (s <= 0) return;
    if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x, y, s, s, s * R); ctx.fill(); }
    else ctx.fillRect(x, y, s, s);
  }
  function q(t, n) { return Math.floor(Math.min(1, Math.max(0, t)) * n) / n; }
  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function Fx(hero) {
    this.hero = hero;
    this.mode = hero.getAttribute('data-hfx-hero') === 'assemble' ? 'assemble' : 'resolve';
    this.cv = hero.querySelector('[data-hfx]');
    this.ctx = this.cv.getContext('2d');
    this.h1 = hero.querySelector('h1');
    this.swapEl = hero.querySelector('[data-swap]');
    this.cells = [];
    this.dis = null;
    this.running = false;
    this.loop = this.loop.bind(this);
    this.resize();
    var self = this;
    window.addEventListener('resize', function () { clearTimeout(self._rs); self._rs = setTimeout(function () { self.resize(); }, 150); });
    var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    Promise.race([fonts, new Promise(function (r) { setTimeout(r, 600); })]).then(function () { requestAnimationFrame(function () { self.start(); }); });
  }

  Fx.prototype.resize = function () {
    var r = this.hero.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
    this.W = Math.max(1, Math.round(r.width)); this.H = Math.max(1, Math.round(r.height));
    this.cv.width = this.W * d; this.cv.height = this.H * d;
    this.ctx.setTransform(d, 0, 0, d, 0, 0);
  };

  /* the title as dots, word by word, exactly where the browser laid it out */
  Fx.prototype.sample = function () {
    var hr = this.hero.getBoundingClientRect(), cs = getComputedStyle(this.h1);
    var fs = parseFloat(cs.fontSize), c = Math.max(4, Math.min(9, Math.round(fs / 11)));
    var W = this.W, H = this.H, off = document.createElement('canvas');
    off.width = W; off.height = H;
    var o = off.getContext('2d');
    o.fillStyle = '#000'; o.textBaseline = 'middle';
    o.font = cs.fontWeight + ' ' + fs + 'px ' + cs.fontFamily;
    if ('letterSpacing' in o) o.letterSpacing = cs.letterSpacing;
    var walker = document.createTreeWalker(this.h1, NodeFilter.SHOW_TEXT), node, rng = document.createRange();
    while ((node = walker.nextNode())) {
      var txt = node.textContent, re = /\S+/g, m;
      while ((m = re.exec(txt))) {
        rng.setStart(node, m.index); rng.setEnd(node, m.index + m[0].length);
        var rects = rng.getClientRects(); if (!rects.length) continue;
        var rc = rects[0], word = cs.textTransform === 'uppercase' ? m[0].toUpperCase() : m[0], w = o.measureText(word).width || 1;
        o.save();
        o.translate(rc.left - hr.left, rc.top - hr.top + rc.height / 2);
        o.scale(rc.width / w, 1);
        o.fillText(word, 0, 0);
        o.restore();
      }
    }
    var er = this.h1.getBoundingClientRect(), sw = this.swapEl ? this.swapEl.getBoundingClientRect() : null;
    var x0 = Math.max(0, Math.floor((er.left - hr.left) / c) * c), y0 = Math.max(0, Math.floor((er.top - hr.top) / c) * c);
    var x1 = Math.min(W, er.right - hr.left + c), y1 = Math.min(H, er.bottom - hr.top + c);
    var data = o.getImageData(0, 0, W, H).data, pts = [];
    for (var y = y0; y < y1; y += c) for (var x = x0; x < x1; x += c) {
      var px = Math.min(W - 1, Math.round(x + c / 2)), py = Math.min(H - 1, Math.round(y + c / 2));
      if (data[(py * W + px) * 4 + 3] > 110) {
        var land = WHITE;
        if (sw) { var ax = px + hr.left, ay = py + hr.top; if (ax >= sw.left && ax <= sw.right && ay >= sw.top && ay <= sw.bottom) land = LIME; }
        pts.push({ x: x, y: y, land: land });
      }
    }
    this.c = c;
    return pts;
  };

  Fx.prototype.start = function () {
    var pts = this.sample(), W = this.W, H = this.H, mix = [WHITE, LIME, ELEC, WHITE], now = performance.now(), end = 0;
    var asm = this.mode === 'assemble';
    this.cells = pts.map(function (p) {
      var f = p.x / W, cell = { x: p.x, y: p.y, land: p.land, col: mix[(Math.random() * mix.length) | 0] };
      if (asm) {
        var e = Math.random();
        cell.sx = e < 0.5 ? -40 - Math.random() * 160 : e < 0.8 ? p.x + (Math.random() - 0.5) * 400 : W * Math.random();
        cell.sy = e < 0.5 ? p.y + (Math.random() - 0.5) * 300 : e < 0.8 ? H + 30 + Math.random() * 80 : H * Math.random();
        cell.a = now + Math.random() * 260 + f * 160; cell.dur = 520;
      } else {
        var j = (Math.random() - 0.5) * 6;
        cell.sx = p.x + Math.round(j) * 8; cell.sy = p.y + Math.round((Math.random() - 0.5) * 3) * 8;
        cell.a = now + f * 180 + Math.random() * 100; cell.dur = 150;
      }
      end = Math.max(end, cell.a + cell.dur);
      return cell;
    });
    this.tFill = end;
    this.revealed = false;
    if (!this.cells.length) { this.reveal(); return; }
    this.cells.forEach(function (cl) { cl.z = end + 40 + (cl.x / W) * 220 + Math.random() * 120; });
    this.kick();
  };

  Fx.prototype.reveal = function () {
    if (this.revealed) return; this.revealed = true;
    this.hero.classList.remove('hfx-pend');
    this.hero.classList.add('play');
    if (this.swapEl && !this._swapOn) this.startSwap();
  };

  Fx.prototype.startSwap = function () {
    var self = this, el = this.swapEl;
    var words = [el.textContent.trim()].concat((el.getAttribute('data-swap') || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean));
    if (words.length < 2) return;
    this._swapOn = true;
    var i = 0;
    setInterval(function () {
      if (document.hidden || self.dis) return;
      var r = self.hero.getBoundingClientRect(); if (r.bottom < 0 || r.top > window.innerHeight) return;
      i = (i + 1) % words.length;
      self.dis = { t: performance.now(), next: words[i], swapped: false };
      self.kick();
    }, 2800);
  };

  /* pixels over the swap word's current box */
  Fx.prototype.cover = function (list, c) {
    var hr = this.hero.getBoundingClientRect(), a = this.swapEl.getBoundingClientRect();
    var X0 = Math.floor((a.left - hr.left) / c) * c, Y0 = Math.floor((a.top - hr.top) / c) * c;
    for (var y = Y0; y < a.bottom - hr.top; y += c) for (var x = X0; x < a.right - hr.left; x += c) list.push({ x: x, y: y, o: Math.random(), col: Math.random() < 0.7 ? LIME : WHITE });
  };

  Fx.prototype.kick = function () { if (!this.running) { this.running = true; requestAnimationFrame(this.loop); } };

  Fx.prototype.loop = function (now) {
    var ctx = this.ctx, c = this.c || 8, busy = false;
    ctx.clearRect(0, 0, this.W, this.H);

    /* intro */
    if (this.cells.length) {
      busy = true;
      if (!this.revealed && (now >= this.tFill || !this.hero.classList.contains('hfx-pend'))) this.reveal();
      var alive = 0;
      for (var k = 0; k < this.cells.length; k++) {
        var P = this.cells[k];
        if (now >= P.z) continue;
        alive++;
        var t = (now - P.a) / P.dur;
        if (t <= 0) continue;
        var f = ease(q(t, this.mode === 'assemble' ? 12 : 3));
        var x = P.sx + (P.x - P.sx) * f, y = P.sy + (P.y - P.sy) * f;
        x = Math.round(x / c) * c; y = Math.round(y / c) * c;
        ctx.fillStyle = t >= 1 ? P.land : P.col;
        rr(ctx, x + 0.5, y + 0.5, c - 1);
      }
      if (!alive) this.cells = [];
    }

    /* swap word dissolve: fill in random order, change the word, clear */
    if (this.dis) {
      busy = true;
      var d = this.dis, T = 420, dt = now - d.t;
      if (!d.cells) { d.cells = []; this.cover(d.cells, c); }
      var fillP = q(dt / T, 7), clearP = q((dt - T - 60) / T, 7);
      if (!d.swapped && dt >= T) { this.swapEl.textContent = d.next; d.swapped = true; this.cover(d.cells, c); } // the new word is covered too
      for (var n = 0; n < d.cells.length; n++) {
        var Q = d.cells[n];
        if (Q.o < fillP && Q.o >= clearP) { ctx.fillStyle = Q.col; rr(ctx, Q.x + 0.5, Q.y + 0.5, c - 1); }
      }
      if (dt > T * 2 + 100) this.dis = null;
    }

    if (busy) requestAnimationFrame(this.loop);
    else { this.running = false; ctx.clearRect(0, 0, this.W, this.H); }
  };

  function boot(scope) {
    (scope || document).querySelectorAll('[data-hfx-hero]').forEach(function (h) {
      if (h._hfx) return;
      h._hfx = true;
      if (reduce || !h.querySelector('[data-hfx]') || !h.querySelector('h1')) { h.classList.remove('hfx-pend'); h.classList.add('play'); return; }
      h._hfx = new Fx(h);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
